import React from "react"
import styled from "styled-components"
import { color, fontFamily } from "../Theme"
import { TRIAL_COPY as C } from "../../copy/trialCopy"
import { ACCESS_STATE, formatTrialDate, getOnboardingUrl } from "../../accessState"

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 10px 16px;
  font-family: ${() => fontFamily()};
  font-size: 14px;
  line-height: 20px;
  background: ${(p) => (p.$warn ? "#FFF4E5" : color("primary-light"))};
  color: ${(p) => (p.$warn ? "#7A4100" : color("heading"))};
  border-bottom: 1px solid ${(p) => (p.$warn ? "#F5D3A0" : color("border"))};
`

const Message = styled.div`
  flex: 1 1 240px;
  min-width: 0;
`

const Action = styled.button`
  border: 0;
  border-radius: 8px;
  padding: 8px 14px;
  min-height: 36px;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  background: ${color("primary")};
  color: #fff;
`

const SideLink = styled.a`
  font-weight: 600;
  color: inherit;
  text-decoration: underline;
`

export default function AccessBanner({ accessState, trial, canChoosePlan, onChoosePlan }) {
  if (accessState !== ACCESS_STATE.TRIAL && accessState !== ACCESS_STATE.READ_ONLY) return null
  const onboardingUrl = getOnboardingUrl()

  if (accessState === ACCESS_STATE.TRIAL) {
    const days = trial?.trialDaysLeft ?? 0
    return (
      <Bar role="status" data-testid="access-banner-trial">
        <Message>
          <strong>{C.trialBannerLead}: {C.trialDaysLeft(days)}.</strong> {C.trialBannerNote}
          {!canChoosePlan && <> {C.trialBannerNonOwner}</>}
        </Message>
        {onboardingUrl && canChoosePlan && (
          <SideLink href={onboardingUrl} target="_blank" rel="noopener noreferrer">{C.onboardingLink}</SideLink>
        )}
        {canChoosePlan && <Action type="button" onClick={onChoosePlan}>{C.choosePlan}</Action>}
      </Bar>
    )
  }

  return (
    <Bar $warn role="status" data-testid="access-banner-read-only">
      <Message>
        <strong>{C.readOnlyTitle}</strong> {C.readOnlyUntil(formatTrialDate(trial?.graceEndsAt))}
        {!canChoosePlan && <> {C.readOnlyNonOwner}</>}
      </Message>
      {canChoosePlan && <Action type="button" onClick={onChoosePlan}>{C.choosePlan}</Action>}
    </Bar>
  )
}
